import React from 'react';
import { IconProps } from './types/Icon.type';

function MarkerIcon(props: IconProps) {
  if (props.groupCode === 'OH') {
    if (props.isHover) {
      return (
        <svg
          width="49"
          height="49"
          viewBox="0 0 49 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="24.4492" cy="24.6845" r="19" fill="#0064FF" />
          <path
            d="M12.4492 22.4237C12.4492 21.9943 12.6681 21.5887 13.0429 21.3233L24.2509 14.4413C24.5329 14.2416 24.9301 14.2416 25.2122 14.4413L35.856 21.3233C36.2309 21.5887 36.4497 21.9943 36.4497 22.4237L36.4497 33.6776C36.4497 34.4508 35.7535 35.0776 34.8947 35.0776H14.0043C13.1454 35.0776 12.4492 34.4508 12.4492 33.6776L12.4492 22.4237Z"
            fill="white"
          />
          <path
            d="M20.0706 27.6543C20.0706 28.2135 19.9606 28.6939 19.7408 29.0953C19.5209 29.4968 19.221 29.8015 18.841 30.0094C18.4611 30.2173 18.0345 30.3213 17.5613 30.3213C17.0834 30.3213 16.6544 30.2173 16.2744 30.0094C15.8945 29.7991 15.5946 29.4932 15.3747 29.0918C15.1549 28.6903 15.0449 28.2111 15.0449 27.6543C15.0449 27.0951 15.1549 26.6148 15.3747 26.2133C15.5946 25.8118 15.8945 25.5071 16.2744 25.2992C16.6544 25.0913 17.0834 24.9874 17.5613 24.9874C18.0345 24.9874 18.4611 25.0913 18.841 25.2992C19.221 25.5071 19.5209 25.8118 19.7408 26.2133C19.9606 26.6148 20.0706 27.0951 20.0706 27.6543ZM16.4501 27.6543C16.4501 28.1299 16.5457 28.4943 16.7369 28.7476C16.928 29.001 17.2029 29.1288 17.5613 29.1312C17.9174 29.1288 18.191 29.001 18.3822 28.7476C18.5734 28.4943 18.6678 28.1299 18.6654 27.6543C18.6678 27.1764 18.5734 26.8107 18.3822 26.5574C18.191 26.3041 17.9174 26.1775 17.5613 26.1775C17.2029 26.1775 16.928 26.3041 16.7369 26.5574C16.5457 26.8107 16.4501 27.1764 16.4501 27.6543Z"
            fill="#0064FF"
          />
          <path
            d="M20.5905 25.0591H22.7986C23.181 25.0591 23.5167 25.1355 23.8059 25.2885C24.0974 25.439 24.3221 25.6517 24.4798 25.9265C24.6399 26.2014 24.72 26.5192 24.72 26.88C24.72 27.2457 24.6387 27.5659 24.4762 27.8407C24.3137 28.1132 24.0843 28.3223 23.788 28.468C23.4916 28.6138 23.1475 28.6867 22.7556 28.6867H21.9526V30.2496H20.5905V25.0591ZM22.4832 27.6257C22.7389 27.6233 22.9384 27.5563 23.0818 27.4249C23.2252 27.2911 23.2957 27.1095 23.2933 26.88C23.2957 26.653 23.2252 26.475 23.0818 26.3459C22.9384 26.2169 22.7389 26.1512 22.4832 26.1488H21.9526V27.6257H22.4832Z"
            fill="#0064FF"
          />
          <path
            d="M25.1108 25.0591H28.8173V26.1631H26.473V27.1023H28.6238V28.2064H26.473V29.1455H28.8102V30.2496H25.1108V25.0591Z"
            fill="#0064FF"
          />
          <path
            d="M33.8539 30.2496H32.714L30.7854 27.4464H30.7496V30.2496H29.3874V25.0591H30.5489L32.4487 27.8479H32.4917V25.0591H33.8539V30.2496Z"
            fill="#0064FF"
          />
        </svg>
      );
    }

    return (
      <svg
        width="49"
        height="49"
        viewBox="0 0 49 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24.2949"
          cy="24.6845"
          r="21.25"
          fill="white"
          stroke="#484848"
          strokeWidth="1.5"
        />
        <path
          d="M9.89453 21.9715C9.89453 21.4563 10.1571 20.9695 10.607 20.651L24.0565 12.3926C24.395 12.153 24.8716 12.153 25.2101 12.3926L37.9827 20.651C38.4325 20.9695 38.6951 21.4563 38.6951 21.9715L38.6951 35.4762C38.6951 36.4041 37.8597 37.1562 36.8291 37.1562H11.7606C10.73 37.1562 9.89455 36.4041 9.89455 35.4762L9.89453 21.9715Z"
          fill="#484848"
        />
        <path
          d="M19.0405 28.2483C19.0405 28.9193 18.9086 29.4957 18.6448 29.9775C18.381 30.4593 18.0211 30.8249 17.5651 31.0744C17.1091 31.3239 16.5973 31.4486 16.0295 31.4486C15.4559 31.4486 14.9412 31.3239 14.4852 31.0744C14.0292 30.822 13.6693 30.455 13.4055 29.9732C13.1417 29.4914 13.0098 28.9164 13.0098 28.2483C13.0098 27.5772 13.1417 27.0008 13.4055 26.519C13.6693 26.0373 14.0292 25.6716 14.4852 25.4221C14.9412 25.1727 15.4559 25.0479 16.0295 25.0479C16.5973 25.0479 17.1091 25.1727 17.5651 25.4221C18.0211 25.6716 18.381 26.0373 18.6448 26.519C18.9086 27.0008 19.0405 27.5772 19.0405 28.2483ZM14.696 28.2483C14.696 28.8189 14.8107 29.2563 15.0401 29.5602C15.2695 29.8642 15.5993 30.0176 16.0295 30.0205C16.4567 30.0176 16.7851 29.8642 17.0145 29.5602C17.2439 29.2563 17.3572 28.8189 17.3543 28.2483C17.3572 27.6747 17.2439 27.236 17.0145 26.932C16.7851 26.628 16.4567 26.476 16.0295 26.476C15.5993 26.476 15.2695 26.628 15.0401 26.932C14.8107 27.236 14.696 27.6747 14.696 28.2483Z"
          fill="white"
        />
        <path
          d="M19.6644 25.1339H22.3142C22.773 25.1339 23.1759 25.2257 23.5229 25.4092C23.8728 25.5899 24.1424 25.8451 24.3316 26.1749C24.5238 26.5047 24.6198 26.8861 24.6198 27.3191C24.6198 27.7579 24.5223 28.1422 24.3273 28.4719C24.1323 28.7989 23.857 29.0498 23.5014 29.2247C23.1458 29.3996 22.7329 29.4871 22.2626 29.4871H21.299V31.3626H19.6644V25.1339ZM21.9357 28.2139C22.2425 28.211 22.482 28.1307 22.654 27.973C22.8261 27.8124 22.9107 27.5944 22.9078 27.3191C22.9107 27.0467 22.8261 26.8331 22.654 26.6782C22.482 26.5233 22.2425 26.4445 21.9357 26.4416H21.299V28.2139H21.9357Z"
          fill="white"
        />
        <path
          d="M25.0889 25.1339H29.5367V26.4588H26.7235V27.5858H29.3044V28.9107H26.7235V30.0377H29.5281V31.3626H25.0889V25.1339Z"
          fill="white"
        />
        <path
          d="M35.5805 31.3626H34.2126L31.8984 27.9988H31.8554V31.3626H30.2208V25.1339H31.6145L33.8943 28.4806H33.9459V25.1339H35.5805V31.3626Z"
          fill="white"
        />
      </svg>
    );
  }

  if (props.isHover) {
    return (
      <svg
        width="49"
        height="49"
        viewBox="0 0 49 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="24.4492" cy="24.4" r="19" fill="#0064FF" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.9273 15.4038C23.1654 15.7083 23.1115 16.1483 22.8069 16.3864L15.9078 21.7799V30.3982L21.8234 30.3978L21.8236 31.7978L15.2079 31.7983C15.0222 31.7983 14.8441 31.7246 14.7129 31.5933C14.5816 31.462 14.5078 31.284 14.5078 31.0983V21.4386C14.5078 21.2232 14.607 21.0198 14.7767 20.8871L21.9447 15.2834C22.2492 15.0453 22.6892 15.0992 22.9273 15.4038Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.2869 15.1267C22.3649 14.7431 21.3492 15.4206 21.3492 16.4193V31.7983L27.6137 31.7983V24.0809L32.4303 25.2026V31.7983L34.883 31.7983C35.6562 31.7983 36.283 31.1715 36.283 30.3983V21.4667C36.283 20.9013 35.9428 20.3913 35.4207 20.1741L23.2869 15.1267Z"
          fill="white"
        />
      </svg>
    );
  }

  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.4492 24.4C46.4492 36.5503 36.5995 46.4 24.4492 46.4C12.299 46.4 2.44922 36.5503 2.44922 24.4C2.44922 12.2498 12.299 2.40002 24.4492 2.40002C36.5995 2.40002 46.4492 12.2498 46.4492 24.4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4492 45.4C36.0472 45.4 45.4492 35.998 45.4492 24.4C45.4492 12.802 36.0472 3.40002 24.4492 3.40002C12.8512 3.40002 3.44922 12.802 3.44922 24.4C3.44922 35.998 12.8512 45.4 24.4492 45.4ZM24.4492 46.4C36.5995 46.4 46.4492 36.5503 46.4492 24.4C46.4492 12.2498 36.5995 2.40002 24.4492 2.40002C12.299 2.40002 2.44922 12.2498 2.44922 24.4C2.44922 36.5503 12.299 46.4 24.4492 46.4Z"
        fill="#E2E2E2"
      />
      <circle cx="24.4492" cy="24.4" r="19" fill="#555555" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9273 15.4038C23.1654 15.7083 23.1115 16.1483 22.8069 16.3864L15.9078 21.7799V30.3982L21.8234 30.3978L21.8236 31.7978L15.2079 31.7983C15.0222 31.7983 14.8441 31.7246 14.7129 31.5933C14.5816 31.462 14.5078 31.284 14.5078 31.0983V21.4386C14.5078 21.2232 14.607 21.0198 14.7767 20.8871L21.9447 15.2834C22.2492 15.0453 22.6892 15.0992 22.9273 15.4038Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2869 15.1267C22.3649 14.7431 21.3492 15.4206 21.3492 16.4193V31.7983L27.6137 31.7983V24.0809L32.4303 25.2026V31.7983L34.883 31.7983C35.6562 31.7983 36.283 31.1715 36.283 30.3983V21.4667C36.283 20.9013 35.9428 20.3913 35.4207 20.1741L23.2869 15.1267Z"
        fill="white"
      />
    </svg>
  );
}

export default MarkerIcon;
